import { useDispatch } from 'react-redux';
import { dataActions, Messages } from 'reducers/data';

const useCartMessage = () => {
    const dispatch = useDispatch();

    const setShowCartMessage = (message: Messages) => {
        dispatch(dataActions.setShowCartMessage(message));

        const timeout = setTimeout(() => {
            dispatch(dataActions.setShowCartMessage(Messages.noMessage));
        }, 4500);

        return () => clearTimeout(timeout);
    };

    return { setShowCartMessage };
};

export default useCartMessage;
